.duration-bar-container {
  --duration-height: 3px;

  height: var(--duration-height);
  width: 100%;
  background-color: var(--rds-foreground-overlay-medium);

  border-radius: var(--duration-height);
  overflow: hidden;
}

.duration-bar-indicator {
  height: 100%;
  background-color: var(--rds-accent-color);
}
